import { useState, useEffect } from 'react';

/**
 * Detector de status de rede do navegador
 * Usa a API nativa window.navigator.onLine
 */
export const useNetworkStatus = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => {
      console.log('🌐 Rede: Online');
      setIsOnline(true);
    };

    const handleOffline = () => {
      console.log('🌐 Rede: Offline');
      setIsOnline(false);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return isOnline;
};
